module.exports = __webpack_public_path__ + "img/lead-13z.eb499323.png";